module.exports = __webpack_public_path__ + "img/renwu.514d76c7.svg";